document.addEventListener('alpine:init', () => {
  Alpine.data('navSpy', () => ({
    activeId: null,
    observer: null,

    init() {
      const links = [...this.$root.querySelectorAll('[data-spy-link]')];

      // Берём только якорные ссылки (#section)
      const anchorLinks = links.filter(a => (a.getAttribute('href') || '').startsWith('#'));
      if (!anchorLinks.length) return;

      const sections = anchorLinks
        .map(a => document.querySelector(a.getAttribute('href')))
        .filter(Boolean);

      if (!sections.length) return;

      // Установим активную секцию при загрузке (если уже на якоре)
      const initialHash = window.location.hash;
      if (initialHash) {
        const initial = document.querySelector(initialHash);
        if (initial?.id) this.activeId = initial.id;
      }

      // IntersectionObserver
      this.observer = new IntersectionObserver((entries) => {
        // Берём те, что пересеклись, и выбираем "главную" (самую близкую к центру)
        const visible = entries.filter(e => e.isIntersecting);
        if (!visible.length) return;

        // Сортировка: ближе к центру viewport — приоритетнее
        const centerY = window.innerHeight / 2;
        visible.sort((a, b) => {
          const aDist = Math.abs(a.boundingClientRect.top + a.boundingClientRect.height/2 - centerY);
          const bDist = Math.abs(b.boundingClientRect.top + b.boundingClientRect.height/2 - centerY);
          return aDist - bDist;
        });

        this.activeId = visible[0].target.id;
      }, {
        root: null,
        rootMargin: '-40% 0px -40% 0px',
        threshold: 0
      });

      sections.forEach(sec => this.observer.observe(sec));
    },

    // Проверяем: ссылка активна, если её href совпадает с текущим activeId
    isActive(el) {
      const href = el.getAttribute('href') || '';
      if (!href.startsWith('#')) return false;
      return this.activeId === href.slice(1);
    },
  }));
});
